import React from "react";
import { HelmetProvider } from "react-helmet-async";
import ErrorBoundary from "./components/ErrorBoundary";
import { AdminProvider } from "./context/AdminContext";
import { AddressProvider } from "./context/AddressContext";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import { SettingsProvider } from "./context/SettingsContext";
import { WishlistProvider } from "./context/WishlistContext";

function AppProviders({ children }) {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <AuthProvider>
          <CartProvider>
            <WishlistProvider>
              <SettingsProvider>
                <CurrencyProvider>
                  <AddressProvider>
                    <AdminProvider>{children}</AdminProvider>
                  </AddressProvider>
                </CurrencyProvider>
              </SettingsProvider>
            </WishlistProvider>
          </CartProvider>
        </AuthProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default AppProviders;
